import { Component, input, output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-open-defects-header',
  templateUrl: './open-defects-header.component.html',
  styleUrls: ['./open-defects-header.component.scss'],
  standalone: false
})
export class OpenDefectsHeaderComponent {

  isMobileApp = input<boolean>();
  emitContinue = output<void>();
  icnNo = input.required<string>();

  constructor(
    private readonly router: Router
  ) { }

  goToAddNewInspection() {
    this.emitContinue.emit();
  }

}
